import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccessService } from '../service/access.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ModErrorComponent} from '../modals/mod-error/mod-error.component';


@Component({
  selector: 'app-access-confirmation',
  templateUrl: './access-confirmation.component.html',
  styleUrls: ['./access-confirmation.component.css']
})
export class AccessConfirmationComponent implements OnInit {
  @Input()id: string;
  status: any; //any=[];
  idS: string; //any=[];
  type: any;
  items:any =[];
  site:any =[];
  selfInfo:any[];


  constructor(private route: ActivatedRoute,
              private dataApi: AccessService,
              private spinner: NgxSpinnerService,
              public dialog: MatDialog,
              private _snackBar: MatSnackBar) {
    this.route.snapshot.paramMap.get('id');
    this.id = this.route.snapshot.paramMap.get('id');
  }
  getAccessResult()
  {
    this.spinner.show("loading")
    this.dataApi.getAccessResult(this.id).subscribe((data: any) => {
      this.items=data;
      this.idS=data.requestNumber;
      this.status= data.status;
      this.type= data.type;
      this.dataApi.getAccessDetails(data.requestNumber).subscribe(
        (dataDetail: any) =>{
          this.spinner.hide("loading");
          this.site=dataDetail;
          this.selfInfo=dataDetail.selfInformation || {};
        },
        ()=>{
          this.spinner.hide("loading")
        })
      },
(err) => {
this.spinner.hide("loading");
if(err.error.error !== 'Invalid token.') {
  this.dialog.open(ModErrorComponent, {
    width: 'auto',
    panelClass: 'myapp-no-padding-dialog',
    });
}
});

  }

  ngOnInit() {
    this.getAccessResult();
  }

  getlang(){

    return sessionStorage.getItem('lang');
  }
}
